export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5510.34f91379.jpg";